import { NavLink } from 'react-router-dom';

const DEFAULT_IMAGE = 'https://stssevastorage.blob.core.windows.net/ykwebsite/background/bg-page-title-2.jpg';

// Shared banner for every inner page: page title plus a breadcrumb trail
// (Home > ...crumbs > current page) rendered as the yellow tab at the bottom.
const PageBanner = ({ title, current, crumbs = [], image = DEFAULT_IMAGE, titleId }) => (
    <section className="page-banner">
        <div className="image-layer" style={{ backgroundImage: `url("${image}")` }}></div>

        <div className="auto-container">
            <h1 id={titleId}>{title}</h1>
        </div>

        <nav className="breadcrumb-box" aria-label="Breadcrumb">
            <div className="auto-container">
                <ul className="bread-crumb clearfix">
                    <li><NavLink to="/USA/Home">Home</NavLink></li>
                    {crumbs.map((i_crumb) => (
                        <li key={i_crumb.to}><NavLink to={i_crumb.to}>{i_crumb.label}</NavLink></li>
                    ))}
                    <li className="active" aria-current="page">{current ?? title}</li>
                </ul>
            </div>
        </nav>
    </section>
);

export default PageBanner;
